import { useAuth } from "react-oidc-context";

// A wrapper for the the function passed to useMutate
// Provides currentUser's accessToken to the underlying api call invoked
const useAuthenticatedMutation = (apiCall) => {
  const auth = useAuth();

  return async (requestParams) => {
    return apiCall({
      ...requestParams,
      accessToken: auth.user?.access_token,
    });
  };
};

export default useAuthenticatedMutation;
